<template>
    <v-data-table
        fixed-header
        v-model="selected"
        single-select
        show-select
        :loading="loading"
        :headers="headers"
        :items="items"
        :items-per-page="-1"
        item-key="case_number"
        hide-default-footer
        @item-selected="setSelectedItem"
    >
        <template v-slot:top>
            <div class="d-flex">
                <div class="mr-4">
                    <v-text-field v-model="search" label="Case Number" hide-details outlined dense></v-text-field>
                </div>
                <div>
                    <v-btn id="search-pms-table" rounded depressed color="primary" @click="searchPatient" >
                        Search
                    </v-btn>
                </div>
            </div>

            <div v-if="search">
                <div v-if="error_data">
                    <p>&nbsp;</p>
                    <hr />
                    <p>&nbsp;</p>
                    <center>
                        <h1 class="error" style="color: #fff; padding: 10px;">{{ error_data.message }}</h1>
                    </center>
                    <p>&nbsp;</p>
                    <hr />
                </div>
            </div>  
        </template>

        <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                    <v-icon @click="viewPatientDetails(item)" v-on="on" v-bind="attrs">
                        mdi-dots-horizontal
                    </v-icon>
                </template>
                <span>View Details</span>
            </v-tooltip>
        </template>

    </v-data-table>
</template>

<script>
import DASHBOARD_STORE from "../../store/dashboard.module";
import PmsConstant from "../../../../js/PmsConstant";
import API from '@/api';
const PmsV2 = API.get('PmsV2');

export default {
    data: () => ({
        selected: [],
        loading: false,
        error_data: null,
        headers: [
            {
                text: "Case Number",
                sortable: false,
                value: "case_number",
            },
            {
                text: "Full Name",
                sortable: false,
                value: "full_name",
            },
            {
                text: "Patient ID",
                sortable: false,
                value: "pms_patient_id"
            },
            { 
                text: "Email Address",
                sortable: false,
                value: "email"
            },
            {   text: "",
                sortable: false,
                value: "actions"
            }
        ],
    }),

    computed: {
      items: {
        get() { return DASHBOARD_STORE.getters['showSeachItems'] },
        set(val) { DASHBOARD_STORE.commit('setSeachItems', val) }
      },

      search: {
        get() { return DASHBOARD_STORE.getters['showCaseSearch'] },
        set(val) { DASHBOARD_STORE.commit('setCaseSearch', val) }
      },
    },

    methods: {
        async searchPatient() {

            console.log("search: "+this.search);

            this.selected = [];

            if (!this.search) return;
            this.loading = true;

            try {

                console.log("retrieved_data: "+data);

                let data = await this.getPatientsViaCaseNumber();
                let formattedData = data.map(item => {
                    return {
                        case_number: item.CaseNumber,
                        name_of_company: item.NameOfCompany,
                        reason_for_encounter: item.ReasonForEncounter,
                        case_title: item.CaseTitle,
                        pms_patient_id: item.PatientDetails?.PatientId,
                        full_name: item.PatientDetails?.FullName,
                        email: item.PatientDetails?.Email,
                        provider: item.PatientDetails?.HealthInsurance,
                        patient_details: item.PatientDetails,
                        full_case_data: item.FullCaseData,
                    }
                });

                console.log('selected data: '. formattedData);
                this.items = formattedData;

            } catch (error) {
                this.items = [];
            } finally {
                this.loading = await false;
            }
        },

        async getPatientsViaCaseNumber() {
            this.error_data = null;
            let params = {
                case_id: this.search
            };
    
            let response = await PmsV2.findCase(params);
            console.log("Search result");
            console.log(response);

            if(response.data.error) {

                this.error_data = response.data;

            } else {
                let patientId = response.data.ResponseBody?.PatientDetails?.PatientGuid;
                
                let patient = await PmsV2.getPatientInformation({
                    patient_id: patientId
                });

                console.log("patient data");
                console.log(patient);

                let formattedResponses = [
                    {
                        CaseNumber: response.data.ResponseBody.CaseNumber,
                        NameOfCompany: response.data.ResponseBody.NameOfCompany,
                        ReasonForEncounter: response.data.ResponseBody.ReasonForEncounter,
                        CaseTitle: response.data.ResponseBody.CaseTitle,
                        FullCaseData: response.data.ResponseBody,
                        PatientDetails: {
                            ...patient.data.ResponseBody,
                            // Height: patient.data.ResponseBody.Height ? patient.data.ResponseBody.Height.replace(/[^0-9.]/g,'') : null, //height in cm
                            // Weight: patient.data.ResponseBody.Weight ? patient.data.ResponseBody.Weight.replace(/[^0-9.]/g,'') : null, //weight in kg
                            Height: patient.data.ResponseBody.Height.replace(/[^0-9.]/g,''), //height in cm
                            Weight: patient.data.ResponseBody.Weight.replace(/[^0-9.]/g,''), //weight in kg
                            Gender: PmsConstant.getGender(patient.data.ResponseBody.GenderId).text,
                            CivilStatus: PmsConstant.getCivilStatus(patient.data.ResponseBody.CivilStatus).text
                        }
                    }
                ];

                console.log("to return data");
                console.log(formattedResponses);

                return formattedResponses;
            }
        },

        viewPatientDetails(item) {

            console.log("[selected search item]", item);

            this.$emit("show:patientCaseDetails", {
                show: true,
                patientDetails: item
            });

            // DASHBOARD_STORE.commit("showPatientPMSCase", true);
        },

        setSelectedItem(item) {
            this.$emit("setSelectedItem", item.item);
        }
    },

    watch: {
      search() {
        this.error_data = null
      },
    }
};
</script>